import { useQueryParam, NumberParam, withDefault } from "use-query-params";
import range from "lodash/range";

export const TAX_YEAR_PARAM_NAME = "year";

const FIRST_TAX_YEAR = 2019;
const CURRENT_YEAR = new Date().getFullYear();

export const getTaxYearOptions = () => range(FIRST_TAX_YEAR, CURRENT_YEAR + 1);

export const getDefaultTaxYear = () => CURRENT_YEAR - 1;

const useTaxYearParam = (defaultTaxYear = getDefaultTaxYear()) =>
  useQueryParam(TAX_YEAR_PARAM_NAME, withDefault(NumberParam, defaultTaxYear));

export default useTaxYearParam;
